import { DEVICE_SOURCE_LIST_FAIL, DEVICE_SOURCE_LIST_REQUEST, DEVICE_SOURCE_LIST_SUCCESS, EQUIPMENT_DETAILS_CLEAR, EQUIPMENT_DETAILS_REQUEST, EQUIPMENT_DETAILS_SUCCESS, EQUIPMENT_LIST_FAIL, EQUIPMENT_LIST_REQUEST, EQUIPMENT_LIST_SUCCESS } from "../constants/equipmentConstants";

export const equipmentListReducer = (
    state = {
        equipment: []
    },
    action
) => {
    switch(action.type) {
        case EQUIPMENT_LIST_REQUEST:
            return {
                loading: true,
                equipment: []
            };

        case EQUIPMENT_LIST_SUCCESS:
            return {
                loading: false,
                equipment: action.payload
            };
            
        case EQUIPMENT_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            }
            
        default:
            return state;    
    }
};

export const deviceSourceListReducer = (
    state = {
        devices: []
    },
    action
) => {
    switch (action.type) {
        case DEVICE_SOURCE_LIST_REQUEST:
            return {
                loading: true,
                devices: []
            };

        case DEVICE_SOURCE_LIST_SUCCESS:    
            return {
                loading: false,
                devices: action.payload
            }

        case DEVICE_SOURCE_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            }
            
        default:
            return state;    
    }
}

export const equipmentDetailsReducer = (
    state = {},
    action
) => {
    switch(action.type) {
        case EQUIPMENT_DETAILS_REQUEST:
            return {
                loading: true
            }

        case EQUIPMENT_DETAILS_SUCCESS:
            return {
                loading: false,
                equipment: action.payload
            }    

        case EQUIPMENT_DETAILS_CLEAR:
            return {}
            
        default:
            return state;    
    }
}